module.exports = __webpack_public_path__ + "static/media/uploadpicoverlay.a4ac64c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/uploadpicoverlay.png
// module id = 588
// module chunks = 0